import numeral from 'numeral';

export default $dispatch => ({
    get loanAmount() {
        return Alpine.store('creditAmount');
    },

    get loanTenure() {
        return Alpine.store('loanTenure');
    },

    get county() {
        return Alpine.store('county');
    },

    get selectedCampaigns() {
        return Alpine.store('selectedMortgageCampaigns');
    },

    enquire() {
        $dispatch('enquire');
    },
});
